var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"wave"},[_vm._v("👋🏽npm ")])
}
var staticRenderFns = []

export { render, staticRenderFns }